import FJActionConstant from "../../constant/FJActionConstant";

const initState = {
  videoSource: '', // 预览的video地址
  screenRecordingType: 0, // 1 录屏 2 录像
  isScreenRecording: false, // 是否正在进行录屏
  currentStage: 1, // 0:初始化状态, 1：显示录像内容， 2：拍照倒计时中, 3:录像倒计时, 4:录像中，5:录屏中， 6：拍照预览， 7：录像预览, 8:录屏预览

  cameraList: [], // 摄像头列表
  microphoneList: [], // 麦克风列表
  cameraActiveIndex: 0,
  microphoneActiveIndex: 0,
  videotapeSrc: '', // 录像的视频流
};

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.CHANGE_SCREEN_RECORDING_TYPE:
      return {
        ...state,
        screenRecordingType: action.data
      };
    case FJActionConstant.SET_SCREEN_RECORDING_STATE:
      return {
        ...state,
        isScreenRecording: action.data
      };
    case FJActionConstant.UPDATE_VIDEO_SOURCE:
      return {
        ...state,
        videoSource: action.data
      };
    case FJActionConstant.SET_CAMERA_LIST:
      return {
        ...state,
        cameraList: action.data.list,
        cameraActiveIndex: action.data.index
      };
    case FJActionConstant.SET_MICROPHONE_LIST:
      return {
        ...state,
        microphoneList: action.data.list,
        microphoneActiveIndex: action.data.index
      };
    case FJActionConstant.SET_VIDEO_TAPE_SRC:
      return {
        ...state,
        videotapeSrc: action.data
      };
    case FJActionConstant.CHANGE_RECORDING_CONFIG:
      return {
        ...state,
        [action.data.type]: action.data.index
      };
    case FJActionConstant.SET_CURRENT_STAGE:
      return {
        ...state,
        currentStage: action.data
      };
    default:
      return state;
  }
}
